<template>
  <div
    class="container application-menu-info slide-bgc"
    @mouseleave="hideMenu"
  >
    <el-scrollbar
      class="auto-height-scrollbar"
      :size="1"
    >
      <div class="title">{{ $t("indexPage.all_menu_title") }}</div>
      <div class="group-info">
        <div
          class="group-item"
          v-for="(menu, index) in groupMenus.childGroup"
          :class="{ 'no-mr': index === 2 }"
          :key="menu.menuId"
          @click="selectMenu(menu)"
        >
          {{ menu.name }}
        </div>
      </div>
      <div
        class="group-info"
        v-for="menu in groupMenus.parentGroup"
        v-show="menu.isShow === 0"
        :key="menu.menuId"
      >
        <div class="name">{{ menu.name }}</div>
        <div
          class="group-item"
          v-for="(sub, index) in menu.children"
          :key="sub.menuId"
          v-show="sub.isShow === 0"
          :title="sub.name"
          :class="{ 'no-mr': index === 2 }"
          @click="selectMenu(sub)"
        >
          {{ sub.name }}
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'application-menu-info',
  props: {
    menus: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    groupMenus () {
      let _res = {
        parentGroup: [],
        childGroup: []
      }
      this.menus.forEach(item => {
        if (item._hasChild) {
          _res.parentGroup.push(item)
        } else {
          _res.childGroup.push(item)
        }
      })
      return _res
    }
  },
  methods: {
    selectMenu (menu) {
      if (menu.openType === 2) {
        window.open(menu.fullUrl)
      } else {
        this.openMenu({
          value: menu.menuId,
          key: 'menuId'
        })
      }
      //        this.$emit('select-menu', menu)
    },
    hideMenu () {
      this.$emit('hide-menu')
    },

    ...mapActions(['openMenu'])
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/mixin";

.application-menu-info.container {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  box-sizing: border-box;
  padding: 20px 0;
  .title {
    padding-left: 14px;
    line-height: 20px;
    color: #9b9b9b;
    overflow: hidden;
    word-wrap: normal;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .group-info {
    margin: 12px 0 32px 0;
    box-sizing: border-box;
    padding: 0 0 0 10px;
    font-size: 0;
    .group-item {
      font-size: 14px;
      display: inline-block;
      // width: 122px;
      // height: 40px;
      // text-align: center;
      // line-height: 40px;
      // color: #4c4c4c;
      // background: #f8f8f8;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      // box-sizing: border-box;
      // padding: 0 4px;
      margin: 4px;
      width: 122px;
      height: 40px;
      padding: 0 8px;
      line-height: 40px;
      text-align: center;
      border-radius: 2px;
      display: inline-block;
      cursor: pointer;
      box-sizing: border-box;
      color: #e2e2e2;
      border: 1px solid #4b4b4b;
      background: #414141;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:hover {
        color: #fff;
        border: 1px solid #878787;
        background: #5f5f5f;
      }
      &.no-mr {
        margin-right: 0;
      }
      cursor: pointer;
    }
    .name {
      padding-left: 4px;
      font-size: 14px;
      margin-bottom: 6px;
      color: #9b9b9b;
    }
  }
}
</style>
